/**
 * add script tag
 * @param {string} url
 */
export const createScript = url => {
  const tag = document.querySelector('script[src="' + url + '"]');
  if (tag) {
    return;
  }
  var s = document.createElement('script');
  s.type = 'text/javascript';
  // s.async = 'async';
  s.src = url;
  var x = document.getElementsByTagName('script')[0];
  // if script
  if (x !== undefined) {
    x.parentNode.insertBefore(s, x);
  } else {
    // insert in head
    var h = document.getElementsByTagName('head')[0];
    h.parentNode.appendChild(s);
  }
};

/**
 * add link tag
 * @param {string} url
 */
export const createStyle = url => {
  const tag = document.querySelector('link[href="' + url + '"]');
  if (tag) {
    return;
  }
  var s = document.createElement('link');
  s.rel = 'stylesheet';
  s.href = url;
  var x = document.getElementsByTagName('link')[0];
  // if link
  if (x !== undefined) {
    x.parentNode.insertBefore(s, x);
  } else {
    // insert in head
    var h = document.getElementsByTagName('head')[0];
    h.parentNode.appendChild(s);
  }
};
